module.exports = __webpack_public_path__ + "static/media/rodape-logo-youtube.48a40fe4.png";